import React, { memo } from 'react';
import ButtonIcon from '../ButtonIcon';
import { IconBackgroundColors, IconColors, IconSizes, IconVariants } from '../../constants';
import CloseIcon from '../../assets/icons/close.svg';
const ButtonClose = ({ size = IconSizes.Medium, variant = IconVariants.Plain, disabled = false, clickHandle = () => null, }) => {
    return (<ButtonIcon size={size} variant={variant} color={IconColors.Primary} backgroundColor={IconBackgroundColors.Primary} disabled={disabled} clickHandle={clickHandle}>
    <CloseIcon />
  </ButtonIcon>);
};
export default memo(ButtonClose);
